import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import utils from "./utils/utils";
import './permission'
import i18n from './i18n/langs';
import BootstrapVue from "bootstrap-vue";
import repeat from './utils/repeat'
import global from "@/assets/style/global.scss";
// import "@/assets/style/elementVariables.scss";
// import "@/assets/global_style.css";
require("./assets/sass/app.scss");
window.Vue = Vue;
Vue.use(BootstrapVue)
Vue.config.productionTip = false
window.GlobalEvent = new Vue;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(utils);
Vue.use(repeat)
const Web3 = require('web3');
window.Web3 = Web3;
window.web3 = new Web3(new Web3.providers.HttpProvider('http://baas-test.chainopen.cn/solc'));
// window.web3 = new Web3(new Web3.providers.HttpProvider(document.location.protocol + window.location.search + "/solc"));
window.axios = require('axios');
import AccountManager from './assets/edit_js/AccountManager';
window.accountManager = new AccountManager();
require('./assets/edit_js/keylistener');
if(location.href.includes('gm') || location.href.includes('7177') ) {
  localStorage.setItem('system', 'gm')
} else {
  localStorage.setItem('system', 'pub')
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
